<script>
	import Vue from 'vue';
	import { fireEvent, events } from 'utilities/analyticsUtilities';
	import utilities from 'utilities';
	import { isVisible } from 'utilities/html';
	import breakpoints from 'utilities/breakpoints';
	import optimizedResize from 'utilities/optimizedResize';

	import ClickElsewhere from 'components/click-elsewhere.vue';
	import OrgLogo from 'components/svg/org-logo.vue';
	import MenuIcon from 'components/svg/menu-icon.vue';

	export default {
		props: {
			routeContext: {
				default: null
			}
		},
		components: {
			'click-elsewhere': ClickElsewhere,
			'org-logo': OrgLogo,
			'menu-icon': MenuIcon
		},
		data() {
			return {
				showMobileMenu: false,
				mobileMenuOpen: false,
				mobileMenuTransitioning: false,
				activeSubNav: '',
				transitioningSubNavs: [],
				navItems: [
					{
						text: 'Explore Content',
						url: '/find-content#!q:/g:/t:/pt:/features:/contentTab:search/',
						homepageClick: 'BROWSE_MAIN'
					},
					{
						text: 'About',
						name: 'about',
						children: [
							{
								text: 'Our Story',
								url: 'https://about.readworks.org/ourstory.html',
								icon: 'fa-solid fa-book',
								outboundLink: 'MAIN_NAV_STORY'
							},
							{
								text: 'Mission & Core Values',
								url: 'https://about.readworks.org/corevalues.html',
								icon: 'fa-solid fa-heart',
								outboundLink: 'MAIN_NAV_VALUES'
							},
							{
								text: 'Team',
								url: 'https://about.readworks.org/our-team.html',
								icon: 'fa-solid fa-users',
								outboundLink: 'MAIN_NAV_TEAM'
							},
							{
								text: 'DEI Commitment',
								url: 'https://about.readworks.org/dei.html',
								icon: 'fa-solid fa-hands-holding',
								outboundLink: 'MAIN_NAV_DEI'
							},
							{
								text: 'Board',
								url: 'https://about.readworks.org/our-team.html#board',
								icon: 'fa-solid fa-people-group',
								outboundLink: 'MAIN_NAV_BOARD'
							},
							{
								text: 'Accessibility Statement',
								url: 'https://about.readworks.org/accessibility-statement.html',
								icon: 'fa-solid fa-universal-access',
								outboundLink: 'MAIN_NAV_A11Y_STATEMENT'
							},
							{
								text: 'Partners',
								url: 'https://about.readworks.org/our-partners.html',
								icon: 'fa-solid fa-handshake',
								outboundLink: 'MAIN_NAV_PARTNERS'
							},
							{
								text: 'Supporters',
								url: 'https://about.readworks.org/our-supporters.html',
								icon: 'fa-solid fa-handshake-angle',
								outboundLink: 'MAIN_NAV_SUPPORTERS'
							}
						]
					},
					{
						text: 'Why Readworks?',
						name: 'why-readworks',
						children: [
							{
								text: 'Research',
								url: 'https://about.readworks.org/the-research.html',
								icon: 'fa-solid fa-book-open-reader',
								outboundLink: 'MAIN_NAV_RESEARCH'
							},
							{
								text: 'Tools',
								url: '/teacher-guide/differentiation-tools.html',
								icon: 'fa-solid fa-screwdriver-wrench',
								homepageClick: 'MAIN_NAV_TOOLS'
							},
							{
								text: 'Privacy',
								url: '/privacy',
								icon: 'fa-solid fa-lock',
								homepageClick: 'MAIN_NAV_PRIVACY'
							},
							{
								text: 'Content',
								url: '/find-content#!q:/g:/t:/pt:/features:/contentTab:search/',
								icon: 'fa-solid fa-book-open',
								homepageClick: 'BROWSE_MAIN'
							}
						]
					},
					{
						text: 'Resources',
						name: 'resources',
						children: [
							{
								text: 'Teacher Guide',
								url: '/teacher-guide',
								icon: 'fa-solid fa-book-open-reader',
								homepageClick: 'MAIN_NAV_TEACHER_GUIDE'
							},
							{
								text: 'Units and Alignments',
								url: '/teacher-guide/alignments.html',
								icon: 'fa-solid fa-ruler',
								homepageClick: 'MAIN_NAV_ALIGNMENTS'
							},
							{
								text: 'Webinars',
								url: '/webinars',
								icon: 'fa-solid fa-laptop',
								homepageClick: 'MAIN_NAV_WEBINARS'
							},
							{
								text: 'Blog',
								url: 'https://about.readworks.org/blog',
								icon: 'fa-solid fa-blog',
								outboundLink: 'MAIN_NAV_BLOG'
							}
						]
					}
				]
			};
		},
		methods: {
			openSubNav(name) {
				this.activeSubNav = name;
			},
			closeSubNav(refocus = false) {
				const activeSubNav = this.activeSubNav;

				if (refocus && activeSubNav) {
					const parentItem = this.$el.querySelector(`[data-nav-item="${activeSubNav}"]`);

					Vue.nextTick(() => {
						parentItem.focus();
					});
				}

				this.activeSubNav = '';
			},
			toggleSubNav(name) {
				const activeSubNav = this.activeSubNav;

				if (activeSubNav !== name) {
					this.openSubNav(name);
				} else {
					this.closeSubNav();
				}
			},
			onSubNavTransitionEnd(name) {
				this.transitioningSubNavs = this.transitioningSubNavs.filter(subNav => name !== subNav);
			},
			subNavIsTransitioning(name) {
				return this.transitioningSubNavs.includes(name);
			},
			removeMenuOpenClass() {
				document.documentElement.classList.remove('menu-open');
			},
			setShowMobileMenu() {
				this.showMobileMenu = !breakpoints.isLargeScreen();
			},
			onResize() {
				this.setShowMobileMenu();

				if (this.showMobileMenu) {
					this.activeSubNav = '';
				} else {
					this.mobileMenuOpen = false;
					this.removeMenuOpenClass();
				}
			},
			refocusMobileTrigger() {
				const mobileTrigger = this.$refs.mobileTrigger;
				const mobileTriggerVisible = !!mobileTrigger && isVisible(mobileTrigger);

				if (mobileTriggerVisible) {
					mobileTrigger.focus();
				}
			},
			toggleMobileMenu() {
				this.mobileMenuOpen = !this.mobileMenuOpen;
			},
			closeMobileMenu() {
				this.mobileMenuOpen = false;
			},
			onMobileMenuTransitionEnd() {
				this.mobileMenuTransitioning = false;

				if (this.mobileMenuOpen) {
					document.documentElement.classList.add('menu-open');
				} else {
					this.refocusMobileTrigger();
					this.removeMenuOpenClass();
				}
			},
			homepageClick(loc) {
				if (loc) {
					fireEvent(events.HOMEPAGE_CLICK, {
						loc
					});
				}
			},
			openLoginModal() {
				this.homepageClick('LOGIN_MAIN');
				this.closeMobileMenu();
				utilities.openModal('#bifurcated-login-modal');
			},
			isActiveItem(item) {
				const routeContext = this.routeContext;
				const currentPath = routeContext && this.routeContext.path;

				if (currentPath && item.url && !item.outboundLink) {
					return currentPath.includes(item.url);
				}

				if (item.children) {
					return item.children.some(this.isActiveItem);
				}

				return false;
			}
		},
		watch: {
			mobileMenuOpen(open) {
				this.mobileMenuTransitioning = true;
			},
			activeSubNav(value, oldValue) {
				let transitioningSubNavs = [...this.transitioningSubNavs];
				if (value) {
					transitioningSubNavs.push(value);
				}
				if (oldValue) {
					transitioningSubNavs.push(oldValue);
				}

				this.transitioningSubNavs = transitioningSubNavs;
			}
		},
		mounted() {
			breakpoints.refreshValue();
			this.setShowMobileMenu();

			optimizedResize.add(this.onResize);
		},
		beforeDestroy() {
			optimizedResize.remove(this.onResize);
			this.removeMenuOpenClass();
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';
	@import 'config/colors';
	@import 'layouts/breakpoints'; // redundant but needed for tests

	html.menu-open {
		overflow: hidden;
	}

	nav.unauth-nav {
		background-color: $c-white;
		padding: 1.5rem 0 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 500;

		@include media(lg) {
			align-items: flex-start;
		}

		.home-link {
			flex: 0 1 14rem;
		}

		.org-logo {
			fill: $c-blue;
		}

		.nav-container {
			--mobile-nav-width: 16rem;
			flex-grow: 1;
			display: flex;
			justify-content: flex-end;

			@include media(lg, max) {
				position: absolute;
				top: 0;
				left: 100vw;
				background-color: $c-white;
				transition: left 0.4s ease-in-out;

				&.open,
				&.transitioning {
					height: 100vh;
					width: var(--mobile-nav-width);
					padding: 1rem;
					flex-flow: column;
					align-items: flex-end;
					box-shadow: 0 0 10px rgba($c-black, 0.15);
					z-index: 1;
				}

				&.open {
					left: calc(100vw - var(--mobile-nav-width));
				}
			}
		}

		.mobile-nav-controls {
			flex-shrink: 0;
			margin-left: 0.5rem;
		}

		.mobile-nav-trigger {
			margin-left: 0.5rem;
			padding: 0.5rem;
			border-radius: 0.5rem;

			&:hover {
				background-color: $c-grey-light;

				.menu-icon {
					fill: $c-slate-dark;
				}
			}
		}

		.mobile-close-button {
			font-size: 1.5rem;
			line-height: 1;
			padding: 0.5rem 0.75rem;
			border-radius: 0.5rem;

			&:hover {
				background-color: $c-grey-light;
				color: $c-slate-dark;
			}
		}

		.menu-icon {
			fill: $c-blue-dark;
		}

		.login-button,
		.donate-button {
			--button-border-color: #{$c-blue-dark};
			--button-hover-background-color: #{$c-blue-accent-1};
			--button-hover-border-color: #{$c-blue-accent-1};
			--button-hover-text-color: #{$c-white};
			font-weight: 500;
		}

		.login-button {
			--button-background-color: #{$c-blue-dark};
			--button-text-color: #{$c-white};
		}

		.desktop-donate-button,
		.desktop-login-button {
			width: 6rem;
			margin-left: 1rem;

			@include media(lg, max) {
				display: none;
			}
		}

		.donate-button-container {
			text-align: center;
			margin: 1rem;

			.donate-button {
				width: 100%;
			}
		}

		.nav-list {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			flex-basis: 100%;
			width: 100%;

			@include media(lg) {
				width: auto;
				flex-basis: auto;
				flex-direction: row;
			}
		}

		.nav-item {
			position: relative;
		}

		.nav-link {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			padding: 0.5rem 1rem;
			line-height: inherit;
			font-weight: 500;
			text-align: left;
			background: none;
			color: $c-slate-dark;
			border: none;
			transition: background-color 0.4s;

			&.active,
			&:hover {
				color: $c-blue-dark;

				.nav-link-text {
					box-shadow: 0 3px 0 0 $c-blue-accent-4;
				}
			}

			@include media(lg) {
				padding: 0.375rem 0.75rem;
				width: auto;
			}
		}

		.submenu-icon {
			margin-left: 0.375rem;
		}

		.sub-nav {
			@include media(lg, max) {
				margin-left: 1rem;
				max-height: 0;
				overflow: hidden;
				transition: max-height 0.2s ease-in-out;

				&.open,
				&.transitioning {
					.sub-nav-item {
						visibility: visible;
					}
				}

				&.open {
					max-height: 1000px;
				}
			}

			@include media(lg) {
				display: none;
				position: absolute;
				top: calc(100% + 1.25rem);
				width: 30rem;
				padding: 1rem 0.5rem;
				border-radius: 0.5rem;
				background-color: $c-white;
				z-index: 1;

				&::before {
					content: '';
					position: absolute;
					display: block;
					width: 0;
					height: 0;
					border: 1rem solid transparent;
					bottom: 100%;
					border-width: 0 1rem 1.5rem;
					border-bottom-color: $c-white;
				}

				&.open {
					display: grid;
					grid-template-columns: 1fr 1fr;
					gap: 0.5rem;
					filter: drop-shadow(0 0 10px rgba($c-black, 0.15));
					-webkit-backdrop-filter: blur(0); // stabilizes drop-shadow in safari

					&.about {
						right: -17rem;

						&::before {
							right: 19.25rem;
						}
					}

					&.why-readworks {
						right: -10rem;

						&::before {
							right: 15rem;
						}
					}

					&.resources {
						right: -8rem;

						&::before {
							right: 11rem;
						}
					}
				}
			}
		}

		.sub-nav-item {
			@include media(lg, max) {
				visibility: hidden;
			}
		}

		.sub-nav-link {
			display: block;
			border-radius: 0.5rem;
			padding: 0.5rem;
			font-size: 0.9412rem;
			transition: background-color 0.4s;

			@include media(lg) {
				padding: 0.5rem 1rem;
			}

			&:hover {
				background-color: $c-grey-light;
				color: $c-slate-dark;
			}

			&.active {
				color: $c-blue-dark;
			}
		}

		.sub-nav-text {
			display: flex;
			align-items: center;
		}

		.sub-nav-icon {
			margin-right: 0.375rem;
			flex: 0 0 1.25rem;
			display: inline-flex;
			justify-content: center;
		}
	}
</style>
<template>
	<click-elsewhere @clicked-elsewhere="closeMobileMenu">
		<nav class="unauth-nav font-roboto">
			<a
				class="home-link"
				href="/"
				aria-current="page"
				@click="homepageClick('MAIN_NAV_HOME')"
				@focus="closeSubNav(false)">
				<org-logo></org-logo>
			</a>
			<div
				class="mobile-nav-controls"
				v-if="showMobileMenu">
				<button
					class="button login-button"
					@click="openLoginModal">
					Login
				</button>
				<button
					class="button -link mobile-nav-trigger"
					ref="mobileTrigger"
					aria-label="Open Navigation Menu"
					:aria-expanded="`${mobileMenuOpen}`"
					@click="toggleMobileMenu"
					@keydown.esc="closeMobileMenu">
					<menu-icon></menu-icon>
				</button>
			</div>
			<div
				class="nav-container"
				:class="{
					open: mobileMenuOpen,
					transitioning: mobileMenuTransitioning
				}"
				@keydown.esc="closeMobileMenu"
				@transitionend.self="onMobileMenuTransitionEnd">
				<button
					v-if="showMobileMenu && (mobileMenuOpen || mobileMenuTransitioning)"
					class="button -link mobile-close-button"
					aria-label="Close menu"
					@click="closeMobileMenu">
					<i class="fa-solid fa-xmark"></i>
				</button>
				<ul
					v-show="!showMobileMenu || mobileMenuOpen || mobileMenuTransitioning"
					class="nav-list list-unstyled">
					<li
						v-for="item in navItems"
						:key="item.text"
						class="nav-item"
						@keydown.esc="closeSubNav(true)">
						<click-elsewhere @clicked-elsewhere="closeSubNav">
							<outbound-link
								v-if="item.url"
								class="nav-link"
								:class="[item.class, { active: isActiveItem(item) }]"
								:href="item.url"
								:data-outbound-link="item.outboundLink"
								:target="item.outboundLink ? '_blank' : '_self'"
								@click.native="homepageClick(item.homepageClick)"
								@focus.native="closeSubNav(false)">
								<span class="nav-link-text">{{ item.text }}</span>
							</outbound-link>
							<template v-else>
								<button
									class="nav-link has-submenu"
									:class="[item.class, { active: isActiveItem(item) }]"
									:aria-expanded="`${activeSubNav === item.name}`"
									:aria-controls="`sub-nav-${item.name}`"
									:data-nav-item="item.name"
									@click="toggleSubNav(item.name)"
									@focus="closeSubNav(false)"
									ref="subNavParent">
									<span class="nav-link-text">{{ item.text }}</span>
									<i
										class="submenu-icon fa-solid fa-chevron-down"
										aria-hidden="true"></i>
								</button>
								<ul
									:id="`sub-nav-${item.name}`"
									class="sub-nav list-unstyled"
									:class="[
										{
											open: activeSubNav === item.name,
											transitioning: subNavIsTransitioning(item.name)
										},
										item.name
									]"
									@transitionend.self="onSubNavTransitionEnd(item.name)">
									<li
										v-for="subNavItem in item.children"
										:key="item.text"
										class="sub-nav-item">
										<outbound-link
											class="sub-nav-link"
											:class="{ active: isActiveItem(subNavItem) }"
											:href="subNavItem.url"
											:data-outbound-link="subNavItem.outboundLink"
											:target="subNavItem.outboundLink ? '_target' : '_self'"
											@click.native="homepageClick(subNavItem.homepageClick)">
											<div class="sub-nav-text">
												<i
													class="sub-nav-icon"
													:class="subNavItem.icon"
													aria-hidden="true"></i>
												{{ subNavItem.text }}
											</div>
										</outbound-link>
									</li>
								</ul>
							</template>
						</click-elsewhere>
					</li>
					<li
						v-if="showMobileMenu && (mobileMenuOpen || mobileMenuTransitioning)"
						class="donate-button-container">
						<outbound-link
							class="button blue-outline donate-button"
							href="https://about.readworks.org/donate.html"
							data-outbound-link="MAIN_NAV_DONATE"
							@focus="closeSubNav(false)">
							Donate
						</outbound-link>
					</li>
				</ul>
				<button
					v-if="showMobileMenu"
					class="mobile-focus-capture hidden-visually"
					:tabindex="mobileMenuOpen ? 0 : -1"
					@focus="closeMobileMenu"></button>
			</div>
			<template v-if="!showMobileMenu">
				<outbound-link
					class="button blue-outline donate-button desktop-donate-button"
					href="https://about.readworks.org/donate.html"
					data-outbound-link="MAIN_NAV_DONATE"
					@focus="closeSubNav(false)">
					Donate
				</outbound-link>
				<button
					class="button login-button desktop-login-button"
					@click="openLoginModal"
					@focus="closeSubNav(false)">
					Login
				</button>
			</template>
		</nav>
	</click-elsewhere>
</template>
